import type { ChatEntry } from "@ark-bot/protocol";

/** This close to the bottom counts as reading the latest, so new bubbles keep the view pinned there. */
export const NEAR_BOTTOM_PX = 60;

/** The scroll container's three numbers, as the DOM reports them. */
export interface ScrollMetrics {
  readonly scrollHeight: number;
  readonly scrollTop: number;
  readonly clientHeight: number;
}

/** Whether the user is reading the latest message, or has scrolled up to read earlier ones. */
export function nearBottom(metrics: ScrollMetrics, within = NEAR_BOTTOM_PX): boolean {
  return metrics.scrollHeight - metrics.scrollTop - metrics.clientHeight < within;
}

/**
 * Whether a message that just landed pulls the view down to it, as WhatsApp
 * does: yes while the user is reading the latest, and yes for their own,
 * wherever they were; anything else arriving while they read above stays
 * below, behind the arrow with the dot.
 */
export function followsArrival(reading: boolean, kind: ChatEntry["kind"]): boolean {
  return reading || kind === "user";
}
